import { useState } from "react";
import { usePluginConfig } from "../../contexts/pluginContext";
import AddressSearchField from "../molecules/AddressSearchField";
import CategoryField from "../molecules/CategoryField";

const AddEventDialog = ({ setShowModalForm }) => {
	const pluginConfig = usePluginConfig();
	const publisherSettings = pluginConfig.publisherSettings;
	const [eventTitle, setEventTitle] = useState("");
	const [categoryId, setCategoryId] = useState();
	const [online, setOnline] = useState(false);
	const [placeId, setPlaceId] = useState();
	const [error, setError] = useState("");

	const openSnapSell = () => {
		const url = new URL(process.env.EVVNT_FORM_URL);
		url.search = new URLSearchParams([
			["partner", publisherSettings.api_key],
			["publisher_id", publisherSettings.publisher.id],
			["form_data[title]", eventTitle],
			["form_data[category_id]", categoryId],
			["form_data[venue][place_id]", placeId],
			["form_data[online]", online],
		]);

		window.open(url, "_blank");
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		const missing = [];
		if (!eventTitle) missing.push("title");
		if (!categoryId) missing.push("valid category");
		if (!placeId) missing.push("valid place address");

		if (missing.length > 0) {
			setError(`Please provide a ${missing.join(", ")}`);
			return;
		}

		setError("");
		openSnapSell();
	};

	return (
		<dialog
			open
			className="fixed z-[1000] items-center inset-0 w-full
              max-w-2xl"
		>
			<div className="flex items-center justify-center text-center p-0 mx-2">
				<div
					className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
					onClick={() => setShowModalForm(false)}
				/>
			</div>
			<span className="inline-block align-middle" aria-hidden="true">
				&#8203;
			</span>
			<div
				className=" bg-white  rounded-lg w-full max-w-2xl text-left shadow-xl transform
                   transition-all align-middle "
			>
				<form className="text-sm" onSubmit={handleSubmit} noValidate>
					<div className="bg-white px-4 pt-5 pb-4 p-6 rounded-lg">
						<div>
							<div className="text-center mt-0 mx-4">
								<h3 className="text-lg leading-6 font-medium text-gray-900 min-w-64">
									Create an Event
								</h3>
							</div>
						</div>
						<div className="mt-2">
							{error && (
								<p className="text-red-600 font-semibold mb-2">{error}</p>
							)}
							<div className="pb-6">
								<div className="label font-semibold mb-1">Event Title</div>
								<input
									className="w-full border rounded p-2"
									type="text"
									value={eventTitle}
									onChange={(e) => setEventTitle(e.target.value)}
									placeholder="e.g. My interesting event..."
								/>
							</div>
							<div className="pb-6">
								<CategoryField setCategoryId={setCategoryId} />
							</div>
							<div className="pb-2">
								<input
									type="checkbox"
									name="virtual_event"
									checked={online}
									onChange={(e) => setOnline(e.target.checked)}
								/>
								<label
									className="label font-semibold mb-1 ml-2"
									htmlFor="virtual_event"
								>
									Virtual Event
								</label>
							</div>
							<div className="pb-2">
								<div className="label font-semibold mb-1">Location</div>
								<AddressSearchField setPlaceId={setPlaceId} />
							</div>
						</div>
					</div>
					<div className="flex flex-row w-full  p-4 z-100 rounded-b-lg">
						<div className="w-1/2 mr-1">
							<button
								className="background-theme text-theme rounded p-2 font-semibold text-sm w-full"
								type="submit"
							>
								Submit
							</button>
						</div>
						<div className="w-1/2 ml-1">
							<button
								className="
                    w-full
                    text-gray-600
                    rounded
                    border
                    p-2
                    font-semibold
                    bg-white
                  "
								onClick={() => setShowModalForm(false)}
							>
								Cancel
							</button>
						</div>
					</div>
				</form>
			</div>
		</dialog>
	);
};

export default AddEventDialog;
